import React from "react";
import { FaCheckCircle } from "react-icons/fa";
import AppStoreLogo from "../../assets/download-on-the-app-store.svg"
import AndroidAppLogo from "../../assets/download-android-app-logo.png"
import TuberDriverLogo from "../../assets/tuber_driver.webp"


const ApplyToDrive = () => {
    return (
        <section className="mb-10 md:mb-32 mt-10">
            <div className="apply-to-drive w-full pt-20 pb-56 px-4 relative">
                <div className="bg-black/60 absolute inset-0"></div>

                <div className="max-w-7xl w-full mx-auto relative">
                    <span className="text-white font-medium mb-2 text-base md:text-lg block">REQUIREMENTS</span>

                    <h1 className="text-3xl md:text-4xl font-bold text-white max-w-[460px] w-full">
                        Ready to make the best decision?
                    </h1>

                    <ul className="mt-10 space-y-2 max-w-[550px] w-full">
                        <li className="flex gap-3 items-center text-white">
                            <FaCheckCircle />
                            <span className="flex-1">A ute, van, truck, or similar vehicle capable of carrying trade and commercial materials.</span>
                        </li>

                        <li className="flex gap-3 items-center text-white">
                            <FaCheckCircle />
                            <span className="flex-1">A valid Australian driver’s licence.</span>
                        </li>

                        <li className="flex gap-3 items-center text-white">
                            <FaCheckCircle />
                            <span className="flex-1">An ABN (Australian Business Number) to get paid. </span>
                        </li>

                        <li className="flex gap-3 items-center text-white">
                            <FaCheckCircle />
                            <span className="flex-1">A smartphone with the Tuber Driver App installed.</span>
                        </li>

                        <li className="flex gap-3 items-center text-white">
                            <FaCheckCircle />
                            <span className="flex-1">A positive attitude and a commitment to reliable service. </span>
                        </li>
                    </ul>
                </div>
            </div>


            <div className="px-4 -mt-32 relative z-30">
                <div className="max-w-7xl mx-auto bg-white shadow-lg rounded-lg p-4 lg:p-12 overflow-hidden grid grid-cols-1 md:grid-cols-3">
                    {/* Contact Info */}
                    <div className="bg-primary text-white py-5 md:py-14 px-5 md:px-8 rounded-lg h-fit">
                        <h3 className="text-2xl font-semibold mb-6">Contact Info</h3>

                        <div className="space-y-4 text-lg">
                            {/* Contact Details */}
                            <div>
                                <p className="font-semibold">Call</p>
                                <p className="text-white/90">0418 806 090</p>
                            </div>
                            <div>
                                <p className="font-semibold">Email</p>
                                <p className="text-white/90">contact@tuber.delivery</p>
                            </div>
                            <div>
                                <p className="font-semibold">Business Hours</p>
                                <p className="text-white/90">9:00 AM – 5:00 PM, Monday to Friday</p>
                            </div>

                            {/* App Download Section */}
                            <div>
                                <p className="font-semibold mb-2">Download the Tuber app!</p>
                                <div className="flex flex-col sm:flex-row gap-4">
                                    {/* Apple App Store */}
                                    <a
                                        href="https://apps.apple.com/au/app/tuber-express-delivery/id1567203793?platform=iphone"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <img src={AppStoreLogo} alt="app-store-logo" loading="lazy" className="h-11" />
                                    </a>

                                    {/* Google Play Store */}
                                    <a
                                        href="https://play.google.com/store/apps/details?id=com.tuber.user&hl=en_AU"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <img src={AndroidAppLogo} alt="android-app-logo" loading="lazy" className="h-11" />
                                    </a>
                                </div>
                            </div>

                            {/* Driver App */}
                            <div>
                                <p className="font-semibold">For Drivers</p>
                                <a
                                    href="https://apps.apple.com/au/app/tuber-driver/id1567211555"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="flex items-center gap-2 mt-2"
                                >
                                    <img src={TuberDriverLogo} alt="" className="h-9 object-cover rounded-md" /> Download Driver App
                                </a>
                            </div>
                        </div>
                    </div>

                    {/* Form Section */}
                    <div className="col-span-2 px-0 md:px-8 py-8">
                        <h2 className="text-3xl font-bold text-headings mb-2">Apply to Drive</h2>
                        <p className="text-light_black mb-8 text-sm md:text-base">
                            Join the Tuber Driver Network. Become a trusted Tuber driver and get paid to deliver building
                            materials to busy tradies—faster, easier, and on your own schedule.
                        </p>

                        {/* FORM - Add your actual form fields and state here */}
                        <form className="block md:grid grid-cols-1 md:grid-cols-2 gap-3 space-y-3 md:space-y-0">
                            <div>
                                <label className="block text-sm mb-1 text-black/70 font-semibold uppercase">Full Name</label>
                                <input type="text" className="border px-3 py-[10px] rounded-md focus:outline-primary w-full" />
                            </div>

                            <div>
                                <label className="block text-sm mb-1 text-black/70 font-semibold uppercase">Email Address </label>
                                <input type="email" className="border px-3 py-[10px] rounded-md focus:outline-primary w-full" />
                            </div>

                            <div>
                                <label className="block text-sm mb-1 text-black/70 font-semibold uppercase">Mobile Number</label>
                                <input type="tel" className="border px-3 py-[10px] rounded-md focus:outline-primary w-full" />
                            </div>

                            <div>
                                <label className="block text-sm mb-1 text-black/70 font-semibold uppercase">Date of Birth</label>
                                <input type="date" className="border px-3 py-[10px] rounded-md focus:outline-primary w-full" />
                            </div>

                            <div className="col-span-2">
                                <label className="block text-sm mb-1 text-black/70 font-semibold uppercase">Residential Address</label>
                                <textarea rows={2} className="border px-3 py-[10px] rounded-md focus:outline-primary w-full" />
                            </div>


                            <div>
                                <label className="block text-sm mb-1 text-black/70 font-semibold uppercase">Driver’s Licence Number</label>
                                <input type="text" className="border px-3 py-[10px] rounded-md focus:outline-primary w-full" />
                            </div>

                            <div>
                                <label className="block text-sm mb-1 text-black/70 font-semibold uppercase">Licence Expiry Date</label>
                                <input type="date" className="border px-3 py-[10px] rounded-md focus:outline-primary w-full" />
                            </div>

                            <div>
                                <label className="block text-sm mb-1 text-black/70 font-semibold uppercase">Vehicle Type (e.g., Ute, Van, Truck)</label>
                                <input type="text" className="border px-3 py-[10px] rounded-md focus:outline-primary w-full" />
                            </div>

                            <div>
                                <label className="block text-sm mb-1 text-black/70 font-semibold uppercase">Vehicle Registration Number</label>
                                <input type="text" className="border px-3 py-[10px] rounded-md focus:outline-primary w-full" />
                            </div>

                            <div>
                                <label className="block text-sm mb-1 text-black/70 font-semibold uppercase">ABN</label>
                                <input type="text" className="border px-3 py-[10px] rounded-md focus:outline-primary w-full" />
                            </div>

                            <div>
                                <label className="block text-sm mb-1 text-black/70 font-semibold uppercase">Availability (Days & Hours) </label>
                                <input type="text" className="border px-3 py-[10px] rounded-md focus:outline-primary w-full" />
                            </div>

                            <div className="col-span-2">
                                <label className="block text-sm mb-1 text-black/70 font-semibold uppercase">Preferred Work Locations/Suburbs</label>
                                <textarea rows={2} className="border px-3 py-[10px] rounded-md focus:outline-primary w-full" />
                            </div>

                            <div className="col-span-2">
                                <label className="block text-sm mb-1 text-black/70 font-semibold uppercase">Preferred Work Locations/Suburbs</label>
                                <select className="border px-3 py-[10px] rounded-md focus:outline-primary w-full custom-select">
                                    <option>Willing to handle heavy lifting?</option>
                                    <option>Yes</option>
                                    <option>No</option>
                                </select>
                            </div>


                            <div className="pt-8 col-span-2">
                                <button type="submit" className="w-full bg-primary rounded-md text-white py-3 px-6 uppercase font-medium hover:bg-opacity-85 transition duration-300">
                                    Submit My Application
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ApplyToDrive;
